import { Component, Input, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';
import { SharedHttpService } from './../../services/shared-http.service';

@Component({
  selector: 'app-prosecution-responses',
  templateUrl: './prosecution-responses.component.html',
  styleUrls: ['./prosecution-responses.component.scss']
})
export class ProsecutionResponsesComponent implements OnInit {
  @Input() eCaseId: any;
  @Input() loadDataFP: Observable<any>;

  prosecutionResponsessArr:any=[];
    previewObj: any;
    prosectiontypesArr: any = [];
    caseDetials: any;
  public loadfromparent = new BehaviorSubject<any>('');

    constructor(private dateformat: DateFormatterService, public sharedService: SharedHttpService, public lookupservice: LookupService, public caseservice: CaseService) { }

    ngOnInit(): void {
        this.prosectiontypesArr = this.lookupservice.getLockup("prosecutionresponsetype");
        this.currentDate = this.sharedService.convertDateToNgbDateStruct(this.today);
        this.caseDetials = this.caseservice.case;
        console.log( 'test data in pr: ',this.caseservice.case);
        this.loadDataFP.subscribe((data) => {

            setTimeout(() => {
              
          this.loadData();
      }, 100);
    });
  }
  loadData(){
    this.sharedService.get(`api/Case/GetProsecutionResponses?ecaseId=${this.eCaseId}`).subscribe(res=>{
      this.prosecutionResponsessArr=res;
    })

    }
    today = new Date();
    currentDate: NgbDateStruct;
    prosecutionResponseTypeId: any;
    decisiondate: any;
    courtName: any;
    description: any;
    ProsecutionResponseId: any;
    onCreateRecord() {
        this.sharedService.post("api/case/AddProsecutionResponse", {
            "prosecutionResponseTypeId": this.prosecutionResponseTypeId,
            "decisiondate": this.decisiondate,
            "courtName": this.courtName,
            "description": this.description,
            "caseId": this.caseservice.case.caseId
        }).subscribe(res => {
            this.ProsecutionResponseId = res.prosecutionResponseId;
            this.loadfromparent.next({ "id": this.ProsecutionResponseId, "IsReadOnly": false });
            this.isInsert = false;
            this.loadData();
        });
    }

    isInsert: any;
    AddProsecution(modal) {
        this.ProsecutionResponseId = null;
       this.loadfromparent.next({ "id": 0, "IsReadOnly": false }); 
        this.sharedService.openXLarge(modal);
        this.isInsert = true;
    }


    AddAttachmentModal(modal, pid, IsReadOnly) {
        this.loadfromparent.next({ "id": pid, "IsReadOnly": IsReadOnly }); 
        this.sharedService.openXLarge(modal);
    
    }

    deleteProsecution(modal,ProsecutionResponseId:any) {
        this.sharedService.openSmall(modal);
        this.ProsecutionResponseId = ProsecutionResponseId;
    }

    onDelete(modal) {
        this.sharedService.get(`api/Case/DeleteProsecutionResponse?ProsecutionResponseId=${this.ProsecutionResponseId}`).subscribe(res => {
            if (res == true) {
                this.loadData();
                this.sharedService.showSuccessKey("DeletedSuccessfully");
                modal.dismiss('Cross click');
            }
        });

    }


    SelectedDateChange($event) {
        this.decisiondate = this.dateformat.ToGregorian2($event);
    }

  previewProsecution(ProsecutionResponseId, modal) {
    this.loadfromparent.next({ "id": ProsecutionResponseId, "IsReadOnly": true });
    this.sharedService.get(`api/Case/GetProsecutionResponse?ProsecutionResponseId=${ProsecutionResponseId}`).subscribe(res=>{
      this.previewObj = {};
      this.previewObj = res;
      this.sharedService.openLarge(modal);
    });
    }





}
